export const ru = {
    'yandex': 'Яндекс',
    'last-streams': 'Прошедшие хуралы',
    'text-stream': 'Текстовая трансляция',
};